import {useMemo} from "react";

export function useCharacterLimitMessage(str: string, template: string, limit: number) {


    const message = useMemo(() => {
        const remaining = limit - str.length;
        return template.replace("{remaining}", `${remaining}`)
    }, [str, template, limit]);


    const exceeded = useMemo(() => {
        return str.length > limit;
    }, [str, limit]);


    return {
        message,
        exceeded,
    }

}